<template lang="pug">
  .table-responsive
    ModalUsoEquipo(:config="configModal" @selectNewOffice="selectNewOffice" v-show="modalStatus")
    ModalDocumentosArt(v-show="modalStatusD" :tipo="tipoFileUp" :articulo="itemSelect" @padre:close="cerrarModalD" @subirDocumento="subirDocumento" @borrarDocumento="verModalDeleteDocumento")
    ModalYN(v-show="modalStatusYN" :config="configModalYN" @padre:close="borrarDocumento")
    table#tbExistencias.table.is-striped.is-fullwidth(v-show='childrensShow.length > 0')
      thead
        tr
          th
            a.button.is-small.is-danger.is-rounded(@click="hideChildrens")
              i.fas.fa-caret-left
              | 
            span &nbspidSAP
          th Tag
          th Ubicación
          th Descripción
          th Imágenes
          th Factura
          th(v-show="childrensShow.some( child => child.tipoAdm == 1)") Póliza
      tbody
        tr(v-for="(data, index) in childrensShow" :key="data.id")
          td
            a.button.is-black.is-rounded.is-small {{ data.idSAP === ''? 's/idSAP' : data.idSAP }}
          td 
            span.tag.is-black(v-show="data.tag !== ''")
              | {{ data.tag }}
          td
            span.tag {{ data.ubicacion }}
          td
            a.button.is-black.is-small.is-rounded(@click="irEditarArticulo(data)")
              | {{ data.categoria }}{{ data.subcategoria !== '' ? ` - ${data.subcategoria}` : '' }}
            a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id)")
              i.fas.fa-history
            br
            span.tag.is-light.is-small(v-show=" data.marca !== ''") Marca: {{ data.marca }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.modelo !== ''") Modelo: {{ data.modelo }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.serie !== ''") Serie: {{ data.serie }} &nbsp&nbsp
            br
            span.tag.is-light.is-small(v-show="data.tipoAdm == 2") Precio Unit. {{ data.precioUnitario | currency }}
          td
            a.button.is-rounded.is-small(@click="verModalD(data, 'images')" :class="getClassTipo(data, '0')")
              i.far.fa-folder-open
              | &nbsp
              span {{ data.documentos == 0 ? ' Sin Documentos' : ` (${(data.documentos.filter( d => d.tipo === '0')).length}) Imágenes`}}
          td
            a.button.is-rounded.is-small(:class="data.rutaFac !== '' ? 'is-success': 'is-warning'" @click="verModalD(data, 'facturas')")
              i.far.fa-folder-open
              | &nbsp
              span Factura
          td(v-show="data.tipoAdm == 1")
            a.button.is-rounded.is-small(@click="verModalD(data, 'polizas')" :class="getClassTipo(data, '2')")
              i.far.fa-folder-open
              | &nbsp
              span Póliza
</template>

<script>
  import ModalUsoEquipo from '../inventario_Componentes/shared/ModalUsoEquipo.vue'
  import ModalDocumentosArt from './shared/ModalDocumentosArt.vue'
  import ModalYN from '@/components/shared/ModalYN.vue'
  import moment from 'moment'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'
  export default {
    name: 'TbChildrens',
    components: { ModalUsoEquipo, ModalDocumentosArt, ModalYN },
    props: {
      childrens: {
        type: Array,
        default: []
      },
      filter: {
        type: String,
        default: 'ALL'
      }
    },
    data() {
      return {
        itemCambiar: {},
        configModal: {},
        modalStatus: false,
        childrensShow: [],
        itemSelect: {},
        modalStatusD: false,
        tipoFileUp: '',
        documentoSelect: {},
        modalStatusYN: false,
        configModalYN: {},
      }
    },
    watch: {
      filter() {
        this.filtrarChildrens()
      },
      childrens() {
        this.filtrarChildrens()
      }
    },
    methods: {
      inciarComponente() {
        this.filtrarChildrens()  
      },
      filtrarChildrens() {
        console.log(`filter: ${this.filter}`)
        this.childrensShow = []
        let filt = ''
        switch (this.filter) {
          case 'TPAc':
            filt = 'TPA'
            break
          case 'IRGEc':
            filt = 'IRGE'
            break
          case 'CORPc':
            filt = 'CORP'
            break
        
          default:
            filt = this.filter
            break
        }

        if (this.filter === 'ALL') {
          this.childrensShow = this.childrens
        } else {
          this.childrensShow = this.childrens.filter( child => child.ubicacion === filt)
        }
      },
      
      getUbicacion (ubi, ofi) {
        let oficinaStr = ''
        switch (ofi) {
          case 'TPA-ALM':
            oficinaStr = 'Almacen'
            break
          case 'TPA-ALS':
            oficinaStr = 'Almacen Sist.'
            break
          case 'TPA-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'TPA-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'TPA-SERV':
            oficinaStr = 'Servidores'
            break;
          case 'TPA-IO':
            oficinaStr = 'Cuarto de IOS'
            break;
          case 'TPA-FAC':
            oficinaStr = 'Facturación'
            break
          case 'TPA-BAS':
            oficinaStr = 'Báscula'
            break
          case 'TPA-GER':
            oficinaStr = 'Gerencia'
            break
          case 'TPA-MUE':
            oficinaStr = 'Muelle'
            break
          case 'TPA-MANT':
            oficinaStr = 'Of. de Mntto.'
            break;
          case 'TPA-TALL':
            oficinaStr = 'Taller de Mntto.'
            break;
          case 'TPA-SEG':
            oficinaStr = 'Of. Seguridad'
            break;
          case 'TPA-PROP':
            oficinaStr = 'Of. Propangol'
            break;
          case 'TPA-MOV':
            oficinaStr = 'Of. Movenergy'
            break;
          case 'TPA-SJ':
            oficinaStr = 'Sala de Juntas'
            break;
          case 'TPA-ACC':
            oficinaStr = 'Accesos'
            break;
          case 'TPA-VIG':
            oficinaStr = 'Vigilancia'
            break;
          case 'TPA-ESF':
            oficinaStr = 'Esféricos'
            break;
          case 'TPA-LLEN':
            oficinaStr = 'Llenaderas'
            break;
          case 'TPA-SJ2':
            oficinaStr = 'Sala de Juntas 2'
            break;
          case 'TPA-REC':
            oficinaStr = 'Recepción'
            break;
          case 'IRGE-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'IRGE-ALM':
            oficinaStr = 'Almacen'
            break
          case 'IRGE-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'IRGE-FAC':
            oficinaStr = 'Facturación'
            break
          case 'IRGE-BAS':
            oficinaStr = 'Báscula'
            break
          case 'IRGE-GER':
            oficinaStr = 'Gerencia'
            break
          case 'IRGE-GADM':
            oficinaStr = 'Gerencia Admin.'
            break
          case 'IRGE-SJ':
            oficinaStr = 'Sala de Juntas'
            break
          case 'IRGE-SEG':
            oficinaStr = 'Seguridad'
            break
          case 'IRGE-IOS':
            oficinaStr = 'Cuarto de IOS'
            break
          case 'IRGE-PEM':
            oficinaStr = 'PEMEX'
            break
          case 'IRGE-ACC':
            oficinaStr = 'Accesos'
            break
          case 'IRGE-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'IRGE-CE':
            oficinaStr = 'Cuarto Eléctrico'
            break
          case 'IRGE-REC':
            oficinaStr = 'Recepción'
            break
          case 'IRGE-OP':
            oficinaStr = 'Operación'
            break
          case 'IRGE-CCP':
            oficinaStr = 'Cuarto Control Plus'
            break
          case 'IRGE-VP':
            oficinaStr = '23 Puntos'
            break
          case 'IRGE-MOV':
            oficinaStr = 'Movenergy'
            break
          case 'IRGE-VIC':
            oficinaStr = 'Vigilancia CUSAEM'
            break
          case 'EB04-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB04-ALG':
            oficinaStr = 'Almacén GIA'
            break
          case 'EB04-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB04-GER':
            oficinaStr = 'Gerencia'
            break
          case 'EB04-SIS':
            oficinaStr = 'Sistemas'
            break
          case 'EB04-INS':
            oficinaStr = 'Instrumentación'
            break
          case 'EB04-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB04-SG':
              oficinaStr = 'Sala de Juntas'
              break
          case 'EB04-TIA':
            oficinaStr = 'Taller Inst/Aut'
            break
          case 'EB03-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB03-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB03-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB02-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB02-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB02-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB01-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB01-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB01-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB00-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB00-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB00-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'ERM-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'ERM-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'ERM-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'VALV-ADM':
            oficinaStr = 'Gabinete'
            break
          case 'CORP-DIR':
            oficinaStr = 'Dirección'
            break
          case 'CORP-GG':
            oficinaStr = 'Gerencia General'
            break
          case 'CORP-GC':
            oficinaStr = 'Contraloría'
            break
          case 'CORP-C':
            oficinaStr = 'Contabilidad'
            break
          case 'CORP-CP':
            oficinaStr = 'Cuentas por Pagar'
            break
          case 'CORP-F':
            oficinaStr = 'Fiscal'
            break
          case 'CORP-SA':
            oficinaStr = 'Seguimiento Ambiental'
            break
          case 'CORP-GR':
            oficinaStr = 'Regulación'
            break
          case 'CORP-ALM':
            oficinaStr = 'Almacén'
            break
          case 'CORP-ALG':
            oficinaStr = 'Almacén GIA'
            break
          case 'CORP-GIS':
            oficinaStr = 'Gerencia Inst. y Sist.'
            break
          case 'CORP-SIT':
            oficinaStr = 'Site'
            break
          case 'CORP-RH':
            oficinaStr = 'Recursos Humanos'
            break
          case 'CORP-LEG':
            oficinaStr = 'Legal'
            break
          case 'CORP-REC':
            oficinaStr = 'Recepción'
            break
          case 'LPGD-V1':
            oficinaStr = 'Válvula 1'
            break
          case 'LPGD-V2':
            oficinaStr = 'Válvula 2'
            break
          case 'LPGD-V3':
            oficinaStr = 'Válvula 3'
            break
          case 'LPGD-V4':
            oficinaStr = 'Válvula 4'
            break
          case 'LPGD-V5':
            oficinaStr = 'Válvula 5'
            break
          case 'LPGD-V6':
            oficinaStr = 'Válvula 6'
            break
          case 'LPGD-V7':
            oficinaStr = 'Válvula 7'
            break
          case 'LPGD-V8':
            oficinaStr = 'Válvula 8'
            break
          case 'LPGD-V9':
            oficinaStr = 'Válvula 9'
            break
          case 'LPGD-V10':
            oficinaStr = 'Válvula 10'
            break
          case 'LPGD-V11':
            oficinaStr = 'Válvula 11'
            break
          case 'LPGD-V12':
            oficinaStr = 'Válvula 12'
            break
          case 'LPGD-V13':
            oficinaStr = 'Válvula 13'
            break
          case 'LPGD-V14':
            oficinaStr = 'Válvula 14'
            break
          case 'LPGD-V15':
            oficinaStr = 'Válvula 15'
            break
          case 'LPGD-V16':
            oficinaStr = 'Válvula 16'
            break
          case 'LPGD-V17':
            oficinaStr = 'Válvula 17'
            break
          case 'LPGD-V18':
            oficinaStr = 'Válvula 18'
            break
          case 'LPGD-V19':
            oficinaStr = 'Válvula 19'
            break
          case 'LPGD-V20':
            oficinaStr = 'Válvula 20'
            break
          case 'LPGD-V21':
            oficinaStr = 'Válvula 21'
            break
          case 'LPGD-V22':
            oficinaStr = 'Válvula 22'
            break
          case 'LPGD-V23':
            oficinaStr = 'Válvula 23'
            break
          case 'LPGD-V24':
            oficinaStr = 'Válvula 24'
            break
          case 'LPGD-V25':
            oficinaStr = 'Válvula 25'
            break
          case 'LPGD-V26':
            oficinaStr = 'Válvula 26'
            break
          case 'LPGD-V1B':
            oficinaStr = 'Válvula 1 BIS'
            break
          case 'LPGD-V2B':
            oficinaStr = 'Válvula 2 BIS'
            break
          case 'LPGD-V3B':
            oficinaStr = 'Válvula 3 BIS'
            break
          case 'LPGD-V4B':
            oficinaStr = 'Válvula 4 BIS'
            break
          case 'LPGD-V5B':
            oficinaStr = 'Válvula 5 BIS'
            break
          case 'LPGD-INT':
            oficinaStr = 'Interconexión'
            break
          case 'TPA-RV':
            oficinaStr = 'Recuperador de vapores'
            break
          case 'TPA-PM':
            oficinaStr = 'Paquete de Medición'
            break
          case 'TPA-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'TPA-SISV':
            oficinaStr = 'Sistema Vickers'
            break
          case 'TPA-SCI':
            oficinaStr = 'Sist. Contra Incendio'
            break
          case 'TPA-CB':
            oficinaStr = 'Cuarto de Baterias'
            break
          case 'EB00-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'EB00-CB':
            oficinaStr = 'Cuarto de Baterias'
            break
          case 'EB00-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'EB00-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'EB00-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'ERM-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'ERM-SAL':
            oficinaStr = 'Salida IRGE'
            break
          case 'ERM-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'ERM-TP':
            oficinaStr = 'Tanque Pulmón'
            break
          case 'ERM-TPRG':
            oficinaStr = 'Tanque de Purga'
            break
          case 'ERM-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'EB04-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'EB04-CAB':
            oficinaStr = 'Cabezales'
            break
          case 'EB04-CB':
            oficinaStr = 'Cobertizo de Bombas'
            break
          case 'EB04-COC':
            oficinaStr = 'Cocina'
            break
          case 'EB04-CTE':
            oficinaStr = 'Cuarto Eléctrico'
            break
          case 'EB04-GEN':
            oficinaStr = 'Generadores'
            break
          case 'EB04-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'EB04-RP':
            oficinaStr = 'Residuos Peligrosos'
            break
          case 'EB04-TALL':
            oficinaStr = 'Taller y Almacén'
            break
          case 'EB04-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'EB04-TORG':
            oficinaStr = 'Tanque de Purga'
            break
          case 'EB04-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'EB04-TRA':
            oficinaStr = 'Transformador'
            break
          case 'IRGE-BOM':
            oficinaStr = 'Bombas LPG'
            break
          case 'IRGE-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'IRGE-CB':
            oficinaStr = 'Cuarto de Bombas'
            break
          case 'IRGE-CCM':
            oficinaStr = 'CCM'
            break
          case 'IRGE-CI':
            oficinaStr = 'Red C.I.'
            break
          case 'IRGE-COMP':
            oficinaStr = 'Area de Compresores'
            break
          case 'IRGE-CONT':
            oficinaStr = 'Contabilidad'
            break
          case 'IRGE-CUB':
            oficinaStr = 'Cubeta'
            break
          case 'IRGE-ESF':
            oficinaStr = 'Esferas'
            break
          case 'IRGE-LLEN':
            oficinaStr = 'Llenaderas'
            break
          case 'IRGE-MANT':
            oficinaStr = 'Of. Mantenimiento'
            break
          case 'IRGE-PROP':
            oficinaStr = 'Of. Propangol'
            break
          case 'IRGE-TA':
            oficinaStr = 'Tanque de Agua'
            break
          case 'IRGE-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'IRGE-TP':
            oficinaStr = 'Tanque Pulmón'
            break
          case 'IRGE-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'IRGE-TRA':
            oficinaStr = 'Area de Trasiegos'
            break
        }
        return `<div class="control">
          <div class="tags has-addons">
            <span class="tag is-dark"><i class="fas fa-map-pin"></i>&nbsp${ubi}</span>
            <span class="tag is-primary">${oficinaStr}</span>
          </div>
        </div>`
      },
      getIpMacAddress (art) {
        let texto
        if (art.direccionIP) {
          if (art.macAddressW) {
              if (art.macAddressE) {
                texto = `<span class="tag is-black">${art.direccionIP}</span>
                        <p class="is-size-7"><b>W.</b> ${art.macAddressW}<br/>
                        <b>E.</b> ${art.macAddressE}<br/>
                        </p>`
              } else {
                texto = `<span class="tag is-black">${art.direccionIP}</span>
                        <p class="is-size-7"><b>W.</b> ${art.macAddressW}<br/>
                        </p>`
              }
          } else {
            if (art.macAddressE) {
              texto = `<span class="tag is-black">${art.direccionIP}</span>
                <p class="is-size-7"><b>E.</b> ${art.macAddressE}<br/>
                </p>`
            } else {
              texto = `<span class="tag is-black">${art.direccionIP}</span>`
            }
          }
        } else {
          if (art.macAddressW) {
              if (art.macAddressE) {
                texto = `<b>W.</b> ${art.macAddressW}<br/>
                        <b>E.</b> ${art.macAddressE}<br/>
                        </p>`
              } else {
                texto = `<b>W.</b> ${art.macAddressW}<br/>
                        </p>`
              }
          } else {
            if (art.macAddressE) {
              texto = `<b>E.</b> ${art.macAddressE}<br/>
                </p>`
            } else {
              texto = ``
            }
          }
        }
        return texto
      },
      getGarantia (art) {
        let texto =''

        if (art.garantia === '0') {

          if (art.terminoGarantia ==='0000-00-00') {
            texto = `<span class="tag is-danger"><i class="fas fa-ban"></i>&nbsp No tiene Garantía</span><br/>
              <p class="is-size-7"><b>Se terminó:</b> <i>No existe Info.</i></p>
              `
          } else {
            texto = `<span class="tag is-danger"><i class="fas fa-ban"></i>&nbsp No tiene Garantía</span><br/>
              <p class="is-size-7"><b>Se terminó:</b> <i>${art.terminoGarantia}</i></p>
              `
          }

        } else {
          if (art.terminoGarantia ==='0000-00-00') {
            texto = `<span class="tag is-success"><i class="fas fa-check-circle"></i>&nbsp Con Garantía</span>`
          } else {
            texto = `<span class="tag is-success"><i class="fas fa-check-circle"></i>&nbsp Con Garantía</span><br/>
              <p class="is-size-7"><b>Termina:</b> <i>${art.terminoGarantia}</i></p>`
          }
        }

        return texto
      },
      verHistoria (id) {
        this.$router.push({ path: `/Inventario/Historia/${id}` } )
      },
      irAResguardos (id) {
        this.$router.push({ path: `/Inventario/Resguardos/${id}` } )
      },
      getOC_FC (art) {
        let texto = ''
        if(art.ordenCompra === '') {

          if (art.fechaCompra === '0000-00-00'){
            texto = `<span class="is-size-7">
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>
            </span>
            `
          } else {
            texto = `<span class="is-size-7">${art.fechaCompra}
                <a class="button is-black is-rounded is-small">
                  <i class="fas fa-history"></i>
                </a>
              </span>
              `
          }
        } else {
            if (art.fechaCompra === '0000-00-00'){
              texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}
              <a class="button is-black is-rounded is-small">
                <i class="fas fa-history"></i>
              </a>
              </span>
              `
            } else {
              texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}</span>
                <span class="is-size-7">${art.fechaCompra}
                  <a class="button is-black is-rounded is-small">
                    <i class="fas fa-history"></i>
                  </a>
                </span>
                `
            }
        }

        return texto
      },
      irEditarArticulo(data) {
        this.$router.push({ path: `/Inventario/ArticuloDetalle/${data.id}` })
      },
      getTipo: function (id) {
        let result;
        let type = this.tipos.filter(tipo => tipo.id === id)
        let tipoEnc = type[0]
        if (tipoEnc.subclase === '') {
          result = tipoEnc.nombre
        } else {
          result = `${tipoEnc.nombre} (${tipoEnc.subclase})`
        }

        return result
      },
      hideChildrens () {
        this.$emit('hideChildrens', true)
      },
      cambiarUbicacion(item) {
        if (this.userLogin.departamento === 3 || this.userLogin.departamento === 1) {
          this.itemCambiar = item
          this.configModal = {
            title: 'Ubicar equipo',
            content: `Seleccione la ubicación y el estatus de: ${item.descripcion}.`,
            textCancel: 'Cancelar',
            textOk: 'Guardar'
          }
          this.modalStatus = true
        }
      },
      selectNewOffice (result) {
        console.log(result)
        if (result === 'close') {
          this.modalStatus = false
          return
        }
        this.isLoading = true
        if ( Object.keys(result).length > 0 ) {
          let id = Date.now()
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')

          let idRec = ''
          let Rec = ''

          if (result.estatus > 8) {
            idRec = result.idUbicacion
            Rec = result.ubicacion
          } else {
            idRec = this.userLogin.id
            Rec = this.userLogin.nombre
          }

          InventarioServices.addUbicacion(id, this.itemCambiar.id, fechaReg, result.ubicacion, result.oficina, this.userLogin.id, this.userLogin.nombre, idRec, Rec, result.estatus)
            .then((data) => {
              if (data.success) {
                this.$emit('hideChildrens', 'update')
                this.displayToast(data.respuesta, 'done', 'OK')
              } else {
                this.displayToast(`Error: ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        }
        this.modalStatus = false
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      getEstado (child) {
        let html = ''
        switch (child.estado) {
          case 7:
            html = ` <span class='tag is-info'><i class="fas fa-laptop-house">&nbspPruebas</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 8:
            html = ` <span class='tag is-warning'><i class="fas fa-tools"></i>&nbspReparación</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 9:
            html = ` <span class='tag is-success'><i class="fas fa-database"></i>&nbspInstalado</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 10:
            html = ` <span class='tag is-danger'><i class="far fa-trash-alt"></i>&nbspDesechado</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
        
          default:
            html = ` <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
        }
        return html
      },

      getClassTipo (item, tipo) {
        const { documentos } = item
        const isFiles = documentos.some( d => d.tipo === tipo)
        return isFiles ? 'is-success' : 'is-warning'
      },
      
      verModalD (data, tipo) {
        this.itemSelect = data
        this.modalStatusD = true
        this.tipoFileUp = tipo
      },

      cerrarModalD () {
        this.itemSelect = {}
        this.modalStatusD = false
      },

      subirDocumento (doctos) {
        this.modalStatusD = false
        this.isLoading = true
        const files = Array.from(doctos)
        if (files.length > 0) {
          var i = 0
          files.forEach(docto => {
            
            const nombreFile = docto.name
            let tipoInt = 0
            if (this.tipoFileUp !== 'facturas') {        
              switch (this.tipoFileUp) {
                case 'images':
                  tipoInt = 0
                  break
                case 'facturas':
                  tipoInt = 1
                  break
                case 'polizas':
                  tipoInt = 2
                  break
                case 'tarjetaCirc':
                  tipoInt = 3
                  break
              }
              InventarioServices.uploadDocumento(this.itemSelect.id, nombreFile, docto, tipoInt)
                .then(data => {
                  if (data.success) { i++}
                  
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                  if (i== doctos.length) {
                    this.isLoading = false
                    this.$emit('updateChildrens', this.itemSelect)
                  }
                })
                .catch( error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })  
            } else {
              InventarioServices.subirFactura(this.itemSelect.id, nombreFile, docto)
                .then( data => {
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                  this.isLoading = false
                  this.$emit('updateChildrens', this.itemSelect)
                })
                .catch(error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })
            }
          })
          
        } else {
          this.displayToast('bubble', 'No hay documentos seleccionadas', 'ban', 'OK')
          this.isLoading = false
        }
        
      },
      
      verModalDeleteDocumento (docto) {
      
        let title = ''
        let content = ''

        switch (this.tipoFileUp) {
          case 'images':
            title = 'Eliminar Documento'
            content = '¿Desea eliminar el documento?'
            break
          case 'facturas':
            title = 'Eliminar Factura'
            content = '¿Desea eliminar la factura?'
            break
          case 'polizas':
            title = 'Eliminar Póliza'
            content = '¿Desea eliminar la póliza?'
            break
        }

        this.configModalYN = {
          title: title,
          content: content,
          textCancel: 'Cancelar',
          textOk: 'Eliminar'
        }
        this.modalStatusD = false
        this.documentoSelect = docto
        this.modalStatusYN = true
      },

      borrarDocumento (result) {
        this.modalStatusYN = false
        this.isLoading = true
        if (result) {
          
          if (this.documentoSelect.tipo === 'documento') {
            InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
              .then(data => {
                this.$emit('updateChildrens', this.itemSelect)
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          } else {
            InventarioServices.deleteFactura(this.documentoSelect.id, this.documentoSelect.rutaFac)
              .then(data => {
                this.$emit('updateChildrens', this.itemSelect)
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          }
        } else {
          this.isLoading = false
          this.modalStatusD = true
        }
        this.documentoSelect = {}
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

    },
    created () {
      this.inciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbChildrens.vue